import React, { useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { colors } from './cellColor';
import { Box, FormControlLabel, Switch } from '@mui/material';

export default function ReportInputChart({ dataGraph, itemsName, exportPdf }) {
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  return (
    <>
      {!exportPdf && (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <FormControlLabel
            label={<Box>Agrupar por tipo</Box>}
            labelPlacement="start"
            control={<Switch checked={checked} onChange={handleChange} />}
          />
        </Box>
      )}
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          width={500}
          height={300}
          data={dataGraph}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip itemStyle={{ color: '#000' }} />
          <Legend />
          {itemsName.map((element, index) => (
            <Bar
              maxBarSize={20}
              dataKey={element.name}
              stackId={checked ? `${element.type}` : undefined}
              opacity={0.7}
              fill={colors[index]}
              isAnimationActive
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </>
  );
}
